import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import MarkerMaps from './MarkerMaps';
import MapLegend from './MapLegend';
import EddiTable from './EddiTable';
import RegionHeader from './RegionHeader';
import Error from './Error';
import ColorsContext from './ColorsContext';
import { getDefaultDate, setLongmonyr } from './routines';

function EddiRegion(props) {
	const monyr = props.date ? props.date : getDefaultDate();
	const areaType = props.areaType;
	
	const [ markers, setMarkers ] = useState(null);
	const [ regionData, setRegionData ] = useState(null);
	const [ regionError, setRegionError ] = useState(false);
	const [ regionColors, setRegionColors ] = useState([]);
    const [ datestr, setDatestr ] = useState();
    const [ match, setMatch ] = useState(false);
	const { levelColors, pctlColors } = useContext(ColorsContext);

	const selectedState = "ma"
	const ptDataFileName = (props.match ? ".." : ".") + "/data/gridpt_eddi_" + monyr + ".json";
	const rgDataFileNameBase = areaType === "region" ? "regional" : "basin";
    const rgDataFileName = (props.match ? ".." : ".") + "/data/" + rgDataFileNameBase + "_eddi_" + monyr + ".json";

	const basin_geodata = require('./geo/majorBasins_geo.json');

    //expected date
    const defdate = monyr.split("-");
    const edateString = defdate.length === 2 
        ? (new Date(parseInt(defdate[0]), parseInt(defdate[1]), 0)).toISOString().slice(0,10)     //expected last day of month
        : monyr;                                                                                  //expected last day of week

	//show monthly May-Dec; weekly May-Nov
    const today = new Date();
    const mon = today.getMonth() + 1;
	const lastmon = defdate.length === 2 ? 12 : 11;
    const eddiOn = mon >= 5 && mon <= lastmon;
	
	const getPointData = () => {
		let allmarkers = [];
		axios.get(ptDataFileName)
		.then(results => {
				results.data.data.forEach(gp => {
					const val = gp["02mn_pctl"]
					let fcolor = 9
					pctlColors.some((e, i) => {
						fcolor = e.color
						return val > e.range[0] && val <= e.range[1]
					})
					allmarkers.push({
						position: gp.position, 
						fillColor: fcolor, 
						data: ["Percentile: " + val]
					});
				});

			setMarkers(allmarkers);
		})
		.catch(err => {
			console.log("Point Data Error: " + err);
			setRegionError(true);
		});
	}

	const getRegionData = () => {
		axios.get(rgDataFileName)
		.then(results => {
			setRegionData(results.data.data);
			let allRegions = [];
			Object.keys(results.data.data).forEach(region => {
				const zone = results.data.data[region].zone
				allRegions[zone] = levelColors.plain;
			});
			setRegionColors(allRegions);
            const longmonyr = setLongmonyr((results.data.data_thru))
            setDatestr(longmonyr)
            setMatch(results.data.data_thru === edateString);
		})
		.catch(err => {
			console.log("Region Data Error: " + err);
			setRegionError(true);
		});
	}

	useEffect(() => {
		getPointData();
		getRegionData();
		setRegionError(false);
		 // eslint-disable-next-line
	}, [])

	return (
		<>
            {eddiOn &&
                <>
                    {!regionError && 
                        <RegionHeader
                            title={"Evaporative Demand Drought Index (EDDI) Summary"}
                            addtext={(match ? "" : "These data usually lag by five days. ") + "Data may be provisional."}
                            buttontext={null}
                            buttonValue={null}
                            handleButtonClick={null}
                        />
                    }
                    {markers &&
                        <div className="mapandlegend-container">
                            <MarkerMaps 
                                selectedState={selectedState} 
                                markers={markers} 
                                regionColors={regionColors}
                                mapTitle={datestr + " 2-Month EDDI Percentiles"}
                                geo={areaType === 'basin' ? basin_geodata : "drought"}
                                markerType={'rectangle'}
                            />
                            <MapLegend 
                                title={"2-Month EDDI Percentiles"}
                            />
                        </div>
                    }
                    {regionData &&
                        <>
                            <EddiTable
                                regionData={regionData}
                                monyr={datestr}
                                areaType={areaType}
                            />
                        </>
                    }
                    {regionError &&
                        <>
                            <Error />
                        </>
                    }
                </>
            }
			{!eddiOn &&
				<div style={{minHeight:"700px"}}>
					<RegionHeader
							title={"Evaporative Demand Drought Index (EDDI)"}
							addtext={"EDDI is only displayed during the months of May through " + (lastmon === 11 ? "November." : " December.")}
					/>
				</div>
			}
	   </>
	);
}

export default EddiRegion;